module.exports = {"wheat":{"date":"2019-7-15","duration":25},"rape":{"date":"2019-7-10","duration":10},"soy":{"date":"2019-9-16","duration":15},"sunflower":{"date":"2019-9-1","duration":15},"corn":{"date":"2019-10-1","duration":40}}


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/cropPlanSettings.json
// module id = 51
// module chunks = 0